module.exports = __webpack_public_path__ + "bb92daeacc01aff64d9937ecbe1be562.png";